import gql from 'graphql-tag';

export const dwellerAccessMediaTypesAvailableFragment = gql`
  fragment dwellerAccessMediaTypesAvailableParts on AccessMediaTypes {
    description
    fieldName
    personHasAccessFacial
  }
`;

export const dwellerUnityReportFragment = gql`
  fragment dwellerUnityReportParts on DwellerUnityReport {
    id
    name
    placeTypeLabel
    treeNodeId
  }
`;

export const dwellerProfileReportFragment = gql`
  fragment dwellerProfileReportParts on DwellerProfileReport {
    id
    name
    fieldName
  }
`;

export const dwellerForReportFragment = gql`
  fragment dwellerForReportParts on DwellerForReport {
    name
    email
    personContextId
    profileId
    profileName
    treeNodeId
    profile {
      ...dwellerProfileReportParts
    }
    unity {
      ...dwellerUnityReportParts
    }
    unityGroup {
      ...dwellerUnityReportParts
    }
  }
  ${dwellerProfileReportFragment}
  ${dwellerUnityReportFragment}
`;

export const profileFeatureFragment = gql`
  fragment profileFeatureParts on ProfileFeature {
    applicationFeatureId
    profilePermissionId
    name
    fieldName
    ableToRead
    ableToWrite
    allowsEdit
  }
`;

export const condominiumProfileFeaturesFragment = gql`
  fragment condominiumProfileFeaturesParts on CondominiumProfileFeatures {
    permissionDefault
    permissions {
      ...profileFeatureParts
    }
  }
  ${profileFeatureFragment}
`;

export const dwellerCreateResponseFragment = gql`
  fragment dwellerCreateResponseParts on DwellerCreateResponse {
    id
  }
`;

export const paginationWithHasNextFragment = gql`
  fragment paginationWithHasNextParts on Pagination {
    page
    pageSize
    hasNext
    hasPrevious
  }
`;

export const partnerDwellerCollectionFragment = gql`
  fragment partnerDwellerCollectionParts on PartnerDwellerV2 {
    personContextId
    personContextCreationDate
    syncStatus
    treeNodeId
    treeNodeParentTreeNodeId
    personId
    name: personName
    email: personEmail
    profileId
    profileName
    profileFieldName
    hasFingerprint: hasFingerPrint
    hasQrCode
    hasRf
    hasTag
    almahIntegrated
    hasFaceId
    unityName
    unityGroupName
    condominiumName
  }
`;
